import React, { Fragment } from 'react';
import {ReactSVG} from "react-svg";

const AppLoading = () => {
    const componentClass = "loading-app-page";
    const isHomePage = window.location.pathname === '/'; //TODO: put this in react-app

    return isHomePage ? <div className={componentClass}>
        <ReactSVG src="/public/assets/img/page-loader.svg" className={`${componentClass}__svg`} />
    </div> : null;
};

export default AppLoading;
